import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class ContentEntryService extends RestfulService<Models.ContentEntry> {

  constructor(private restService: RestService) {
    super(Models.ContentEntry);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('content-entries');
  }

}
